module.exports = __webpack_public_path__ + "img/carbon_sinks.0009676f.png";